import {
    fetchUser,
    fetchTranslationMessages,
    fetchPageData,
    fetchGamePlatforms,
    fetchBaseDataGamePlatforms,
    fetchLayoutParts,
    fetchWinnerList,
    fetchPromotionsData,
    fetchNews,
    fetchSliderNews,
    fetchUserNotifications,
    fetchNewsTags,
    fetchNewsCategories,
    fetchHelpCategories,
    fetchUserBalance,
    fetchNewsItem,
    fetchGamePlatformItem,
    fetchGameVirtualCategoryItem,
    fetchGameCategoryItemBySlug,
    fetchPlatformGames,
    fetchSliderPromotions,
    fetchLotteryCurrentData,
    fetchLotteryPastData,
    fetchLotteryFutureData,
    fetchLotteryTicketsData,
    fetchLotteryWinnersData,
    fetchFortuneWheels,
    fetchTournament,
    fetchTournaments,
    // fetchMyTournament,
    fetchCategoryGames, fetchSliderSlides, fetchTransactionsHistory, fetchVipLevels,
} from '../api';

import {getPageDataKey, getPromotionsDataKey} from '../util/cache/cachekeyRepository';
import addPropertiesToApiData from "../api/addPropertiesToApiData";

export default {
    FETCH_USER: ({commit, state}, data) => {
        if (state.user && !data.mustReload) {
            return Promise.resolve(state.user);
        } else {
            return new Promise(((resolve, reject) => {
                fetchUser(data)
                    .then(user => {
                        if (user) {
                            commit('SET_USER', user);
                        } else {
                            commit('SET_USER', null);
                        }

                        resolve(user);
                    })
                    .catch(error => reject(error));
            }));
        }
    },

    FETCH_USER_BALANCE: ({commit, state}) => {
        return fetchUserBalance(addPropertiesToApiData({}, state))
            .then(balance => commit('SET_USER_BALANCE', balance));
    },

    FETCH_USER_NOTIFICATIONS: ({commit, state}, data) => {
        if (state.userNotifications) {
            return Promise.resolve(state.userNotifications);
        } else {
            return new Promise(((resolve, reject) => {
                fetchUserNotifications(data)
                    .then(notifications => {
                        commit('SET_USER_NOTIFICATIONS', notifications);
                        resolve(notifications);
                    })
                    .catch(error => reject(error));
            }));
        }
    },

    FETCH_PLAYER_TRANSACTIONS: ({commit, state}, data) => {
        if (!data.mustReload && state.playerTransactions) {
            return Promise.resolve(state.playerTransactions);
        } else {
            return new Promise(((resolve, reject) => {
                fetchTransactionsHistory(data)
                    .then(transactions => {
                        commit('SET_PLAYER_TRANSACTIONS', transactions);
                        resolve(transactions);
                    })
                    .catch(error => reject(error));
            }));
        }
    },

    FETCH_TRANSLATION_MESSAGES: ({commit, state}, data) => {
        if (state.translationMessages && !data.appendMode) {
            return Promise.resolve(state.translationMessages);
        } else {
            return new Promise(((resolve, reject) => {
                fetchTranslationMessages(data)
                    .then(messages => {
                        !data.appendMode && commit('SET_TRANSLATION_MESSAGES', messages);
                        resolve(messages);
                    })
                    .catch(error => reject(error));
            }))
        }
    },

    FETCH_PAGE_DATA: ({commit, state, getters}, {apiData, route}) => {
        let url = route.meta.backUrlTemplate;

        let pageData = getters.getPageData(route);

        if (pageData) {
            return Promise.resolve(pageData);
        } else {
            let pageCacheKey = getPageDataKey(route);

            return new Promise(((resolve, reject) => {
                fetchPageData(url, apiData, pageCacheKey)
                    .then(pageData => {
                        commit('SET_PAGE_DATA', {
                            path: pageCacheKey,
                            pageData,
                        });

                        resolve(pageData);
                    })
                    .catch(error => reject(error));
            }));
        }
    },

    FETCH_LAYOUT_PARTS: ({commit, state}, data) => {
        if (state.layoutParts && !data.mustReload) {
            return Promise.resolve(state.layoutParts);
        } else {
            return new Promise(((resolve, reject) => {
                fetchLayoutParts(data)
                    .then(layoutParts => {
                        commit('SET_LAYOUT_PARTS', layoutParts);
                        resolve(layoutParts);
                    })
                    .catch(error => reject(error));
            }));
        }
    },

    FETCH_GAME_PLATFORMS: ({commit, state}, data) => {
        if (state.gamePlatformsData && !data.loadMore && !data.mustReload) {
            return Promise.resolve(state.gamePlatformsData);
        } else {
            return new Promise((resolve, reject) => {
                fetchGamePlatforms(data)
                    .then(platformsData => {
                        if (data.loadMore && !data.mustReload) {
                            commit('APPEND_GAME_PLATFORMS', platformsData);
                        } else {
                            commit('SET_GAME_PLATFORMS', platformsData);
                        }

                        resolve(platformsData);
                    }).catch(error => reject(error));
            });
        }
    },

    FETCH_BASE_DATA_GAME_PLATFORMS: ({commit, state}, data) => {
        if (state.baseDataGamePlatforms.length) {
            return Promise.resolve(state.baseDataGamePlatforms);
        } else {
            return new Promise((resolve, reject) => {
                fetchBaseDataGamePlatforms(data).then(platforms => {
                    commit('SET_BASE_DATA_GAME_PLATFORMS', platforms);
                    resolve(platforms)
                })
                    .catch(error => reject(error));
            });
        }
    },

    FETCH_PLATFORM_GAMES_BY_ID: ({commit, state}, data) => {
        let platformId = data.platformId;

        let storedGamesData = state.platformGames[platformId];

        let canUseStoredData = storedGamesData && (data.userId && storedGamesData.isGamesFilteredByUser || !data.userId && !storedGamesData.isGamesFilteredByUser) && data.count && (storedGamesData.games.length >= data.count || storedGamesData.games.length === storedGamesData.totalGamesCount);

        if (canUseStoredData) {
            return Promise.resolve(storedGamesData);
        } else {
            return new Promise((resolve, reject) => {
                fetchPlatformGames(data)
                    .then(gamesData => {
                        commit('SET_PLATFORM_GAMES_BY_SLUG', {gamesData, platformId});
                        resolve(gamesData);
                    })
                    .catch(error => reject(error));
            });
        }
    },

    FETCH_GAME_PLATFORM_ITEM: ({commit, state}, data) => {
        let slug = data.slug;

        if (state.gamePlatformItem[slug]) {
            return Promise.resolve(state.gamePlatformItem[slug]);
        } else {
            return new Promise((resolve, reject) => {
                fetchGamePlatformItem(data).then(platform => {
                    commit('SET_GAME_PLATFORM_ITEM', {platform, slug});
                    resolve(platform)
                })
                    .catch(error => reject(error));
            });
        }
    },

    FETCH_GAME_CATEGORY_ITEM_BY_SLUG: ({commit, state}, data) => {
        let slug = data.slug;

        if (state.gamesCategories.slug[slug]) {
            return Promise.resolve(state.gamesCategories.slug[slug]);
        } else {
            return new Promise((resolve, reject) => {
                fetchGameCategoryItemBySlug(data).then(category => {
                    commit('SET_GAME_CATEGORY_ITEM_BY_SLUG', {category, slug});
                    resolve(category);
                })
                    .catch(error => reject(error));
            });
        }
    },

    FETCH_GAME_VIRTUAL_CATEGORY_ITEM: ({commit, state}, data) => {
        let apiId = data.apiId;

        if (state.gamesCategories.virtual[apiId]) {
            return Promise.resolve(state.gamesCategories.virtual[apiId]);
        } else {
            return new Promise((resolve, reject) => {
                fetchGameVirtualCategoryItem(data).then(category => {
                    commit('SET_VIRTUAL_GAME_CATEGORY_ITEM', {category, apiId});
                    resolve(category)
                })
                    .catch(error => reject(error));
            });
        }
    },

    FETCH_CATEGORY_GAMES_BY_ID: ({commit, state}, data) => {
        let categoryId = data.categoryId;
        let virtualCategoryInterfaceId = data.virtualCategoryInterfaceId;

        let storedGamesData = virtualCategoryInterfaceId ? state.virtualCategoryGames[virtualCategoryInterfaceId] : state.categoryGames[categoryId];

        let canUseStoredData = storedGamesData && !data.mustReload && !storedGamesData.mustReload && (data.userId && storedGamesData.isGamesFilteredByUser || !data.userId && !storedGamesData.isGamesFilteredByUser) && data.count && (storedGamesData.games.length >= data.count || storedGamesData.games.length === storedGamesData.totalGamesCount);

        if (canUseStoredData) {
            return Promise.resolve(storedGamesData);
        } else {
            return new Promise((resolve, reject) => {
                fetchCategoryGames(data)
                    .then(gamesData => {
                        virtualCategoryInterfaceId ? commit('SET_VIRTUAL_CATEGORY_GAMES_BY_INTERFACE_ID', {
                            gamesData,
                            virtualCategoryInterfaceId,
                        }) : commit('SET_CATEGORY_GAMES_BY_ID', {
                            gamesData,
                            categoryId,
                        });

                        resolve(gamesData);
                    })
                    .catch(error => reject(error));
            });
        }
    },

    FETCH_WINNER_LIST: ({commit, state}, data) => {
        if (state.winnerList.length) {
            return Promise.resolve(state.winnerList);
        } else {
            return new Promise((resolve, reject) => {
                fetchWinnerList(data)
                    .then(list => {
                        commit('SET_WINNER_LIST', list);
                        resolve(list);
                    })
                    .catch(error => reject(error));
            });
        }
    },

    FETCH_PAGE_NEWS: ({commit, state}, data) => {
        let page = data.page;

        return new Promise((resolve, reject) => {
            fetchNews(data)
                .then(newsData => {
                    let pageNews = newsData.newsItems;
                    commit('SET_PAGE_NEWS', {pageNews, page});

                    commit('SET_NEWS_PAGES_COUNT', newsData.totalPagesCount);

                    resolve(newsData);
                })
                .catch(error => reject(error));
        });
    },

    FETCH_NEWS_ITEM: ({commit, state}, data) => {
        let newsItemSlug = data.slug;

        if (state.newsItem[newsItemSlug]) {
            return Promise.resolve(state.newsItem[newsItemSlug]);
        } else {
            return new Promise((resolve, reject) => {
                fetchNewsItem(data)
                    .then(newsItem => {
                        commit('SET_NEWS_ITEM', {newsItem, newsItemSlug});
                        resolve(newsItem);
                    })
                    .catch(error => reject(error));
            });
        }
    },

    FETCH_SLIDER_NEWS: ({commit, state}, data) => {
        if (state.sliderNews.length) {
            return Promise.resolve(state.sliderNews);
        } else {
            return new Promise((resolve, reject) => {
                fetchSliderNews(data)
                    .then(news => {
                        commit('SET_SLIDER_NEWS', news);
                        resolve(news);
                    })
                    .catch(error => reject(error));
            });
        }
    },

    FETCH_PROMOTIONS_DATA: ({commit, state}, data) => {
        let cacheKey = getPromotionsDataKey(data);

        if (state.promotionsData && !data.mustReload && state.promotionsData.cacheKey === cacheKey) {
            return Promise.resolve(state.promotionsData);
        } else {
            return new Promise(((resolve, reject) => {
                fetchPromotionsData(data)
                    .then(promotionsData => {
                        promotionsData.cacheKey = cacheKey;

                        commit('SET_PROMOTIONS_DATA', promotionsData);
                        resolve(promotionsData);
                    })
                    .catch(error => reject(error));
            }));
        }
    },

    FETCH_SLIDER_PROMOTIONS: ({commit, state}, data) => {
        let cacheKey = getPromotionsDataKey(data);

        if (state.sliderPromotionsData && !data.mustReload && state.sliderPromotionsData.cacheKey === cacheKey) {
            return Promise.resolve(state.sliderPromotionsData);
        } else {
            return new Promise((resolve, reject) => {
                fetchSliderPromotions(data)
                    .then(promotionsData => {
                        promotionsData.cacheKey = cacheKey;

                        commit('SET_SLIDER_PROMOTIONS', promotionsData);
                        resolve(promotionsData);
                    })
                    .catch(error => reject(error));
            });
        }
    },

    FETCH_SLIDER_SLIDES: ({commit, state}, data) => {
        let sliderId = data.sliderId;

        if (state.sliderSlides[sliderId] && !data.mustReload) {
            return Promise.resolve(state.sliderSlides[sliderId]);
        } else {
            return new Promise((resolve, reject) => {
                fetchSliderSlides(data)
                    .then(slides => {
                        commit('SET_SLIDER_SLIDES', {slides, sliderId});
                        resolve(slides);
                    })
                    .catch(error => reject(error));
            });
        }
    },

    FETCH_NEWS_TAGS: ({commit, state}, data) => {
        if (state.newsTags.length) {
            return Promise.resolve(state.newsTags);
        } else {
            return new Promise((resolve, reject) => {
                fetchNewsTags(data).then(tags => {
                    commit('SET_NEWS_TAGS', tags);
                    resolve(tags);
                }).catch(error => reject(error));
            });
        }
    },

    FETCH_NEWS_CATEGORIES: ({commit, state}, data) => {
        if (state.newsCategories.length) {
            return Promise.resolve(state.newsCategories);
        } else {
            return new Promise((resolve, reject) => {
                fetchNewsCategories(data).then(categories => {
                    commit('SET_NEWS_CATEGORIES', categories);
                    resolve(categories);
                }).catch(error => reject(error));
            });
        }
    },

    FETCH_HELP_CATEGORIES: ({commit, state}, data) => {
        if (state.helpCategories.length) {
            return Promise.resolve(state.helpCategories);
        } else {
            return new Promise((resolve, reject) => {
                fetchHelpCategories(data)
                    .then(categories => {
                        commit('SET_HELP_CATEGORIES', categories);
                        resolve(categories);
                    })
                    .catch(error => reject(error));
            });
        }
    },

    FETCH_LOTTERY_CURRENT_DATA: ({commit, state}, data) => {
        if (state.lotteryData.current && state.lotteryData.current) {
            return Promise.resolve(state.lotteryData.current);
        } else {
            return new Promise((resolve, reject) => {
                fetchLotteryCurrentData(data).then(response => {
                    commit('SET_LOTTERY_CURRENT_DATA', response);
                    resolve(response);
                }).catch(error => reject(error));
            });
        }
    },

    FETCH_LOTTERY_FUTURE_DATA: ({commit, state}, data) => {
        if (state.lotteryData.future.length) {
            return Promise.resolve(state.lotteryData.future);
        } else {
            return new Promise((resolve, reject) => {
                fetchLotteryFutureData(data).then(response => {
                    commit('SET_LOTTERY_FUTURE_DATA', response);
                    resolve(response);
                }).catch(error => reject(error));
            });
        }
    },

    FETCH_LOTTERY_PAST_DATA: ({commit, state}, data) => {
        if (state.lotteryData.past.length) {
            return Promise.resolve(state.lotteryData.past);
        } else {
            return new Promise((resolve, reject) => {
                fetchLotteryPastData(data).then(response => {
                    response.forEach((item, index) => {
                        item.index = index;
                    });

                    commit('SET_LOTTERY_PAST_DATA', response);
                    resolve(response);
                }).catch(error => reject(error));
            });
        }
    },

    FETCH_LOTTERY_TICKETS_DATA: ({commit, state}, data) => {
        return new Promise((resolve, reject) => {
            fetchLotteryTicketsData(data).then(response => {
                commit('SET_LOTTERY_TICKETS_DATA', response);
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },

    FETCH_LOTTERY_WINNERS_DATA: ({commit, state}, data) => {
        if (state.lotteryData.winners.length) {
            return Promise.resolve(state.lotteryData.winners);
        } else {
            return new Promise((resolve, reject) => {
                fetchLotteryWinnersData(data).then(response => {
                    commit('SET_LOTTERY_WINNERS_DATA', response);
                    resolve(response);
                }).catch(error => reject(error));
            });
        }
    },

    FETCH_FORTUNE_WHEELS: ({commit, state}, data) => {
        if (state.fortuneWheels.length && !data.reload) {
            return Promise.resolve(state.fortuneWheels);
        } else {
            return new Promise((resolve, reject) => {
                fetchFortuneWheels(data).then(response => {
                    commit('SET_FORTUNE_WHEELS', response.fortuneWheels);
                    resolve(response);
                }).catch(error => reject(error));
            });
        }
    },

    FETCH_TOURNAMENT: ({commit, state}, data) => {
        let slug = data.slug;

        return new Promise((resolve, reject) => {
            fetchTournament(data).then(tournament => {
                commit('SET_TOURNAMENT', {tournament, slug});
                resolve(tournament);
            }).catch(error => reject(error));
        });

        /*if (state.tournament.item[slug]) {
            return Promise.resolve(state.tournament.item[slug]);
        } else {
            return new Promise((resolve, reject) => {
                fetchTournament(data).then(tournament => {
                    commit('SET_TOURNAMENT', {tournament, slug});
                    resolve(tournament);
                }).catch(error => reject(error));
            });
        }*/
    },

    FETCH_TOURNAMENTS: ({commit, state}, data) => {
        return new Promise((resolve, reject) => {
            fetchTournaments(data).then(tournaments => {
                commit('SET_TOURNAMENTS', tournaments);
                resolve(tournaments);
            }).catch(error => reject(error));
        });

        /*if (Object.keys(state.tournament.list).length) {
            return Promise.resolve(state.tournament.list);
        } else {
            return new Promise((resolve, reject) => {
                fetchTournaments(data).then(tournaments => {
                    commit('SET_TOURNAMENTS', tournaments);
                    resolve(tournaments);
                }).catch(error => reject(error));
            });
        }*/
    },

    // FETCH_MY_TOURNAMENT: ({commit, state}, data) => {
    //     return new Promise((resolve, reject) => {
    //         fetchMyTournament(data).then(response => {
    //             commit('SET_MY_TOURNAMENT', response.result);
    //             resolve(response);
    //         }).catch(error => {
    //             reject(error);
    //         });
    //     });
    // },

    FETCH_VIP_LEVELS: ({commit, state}, data) => {
        if (state.vipLevels.length) {
            return Promise.resolve(state.vipLevels);
        } else {
            return new Promise((resolve, reject) => {
                fetchVipLevels(data).then(response => {
                    commit('SET_VIP_LEVELS', response);
                    resolve(response);
                }).catch(error => reject(error));
            });
        }
    },
}
